import {axiosRequest} from "@/store/actions/abstract/axiosRequest";

export default {
    async actionEvent({getters}, params) {
        return await axiosRequest(
            `${getters.getApiUrl}/${getters.getApiVersion}/pension/action-event`,
            "post",
            localStorage.getItem("token"),
            params
        );
    },
    async declineEvent({getters}, params) {
        return await axiosRequest(
            `${getters.getApiUrl}/${getters.getApiVersion}/pension/decline-event`,
            "post",
            localStorage.getItem("token"),
            params
        );
    },
};
